const topicTags = [
  { label: '科幻大片', hot: true },
  { label: '国产喜剧', hot: true },
  { label: '悬疑惊悚', hot: false },
  { label: '动作冒险', hot: true },
  { label: '动画电影', hot: false },
  { label: '经典怀旧', hot: false },
  { label: '院线新片', hot: true },
  { label: '高分神作', hot: false },
  { label: '纪录片', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              热门话题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              影迷们正在热议的电影话题标签，点击发现同好与精彩讨论
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            {topicTags.map((tag) => (
              <span
                key={tag.label}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 ${
                  tag.hot
                    ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                    : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200'
                }`}
              >
                {tag.hot && <i className="ri-fire-fill text-xs text-accent-500"></i>}
                {tag.label}
                {tag.hot && (
                  <span className="text-xs opacity-70 ml-0.5">热</span>
                )}
              </span>
            ))}
          </div>
          <p className="text-center text-xs text-foreground-500 mt-6">
            以上话题基于近 7 日用户搜索与讨论热度自动生成
          </p>
        </div>
      </div>
    </section>
  );
}